<template>
    <div class="card-deal-params-block" v-loading="loading">
        <el-row>
            <el-col :span="10">
                <span class="gray">
                    Имя
                </span>
            </el-col>
            <el-col :span="14" :class="{ 'error-input': errors.name }">
                <template v-if="editMode">
                    <el-input v-model="currentContact.name" size="mini" />
                    <div class="field-error" v-if="errors.name" v-text="errors.name[0]"></div>
                </template>
                <template v-else>
                    <span class="gray">
                        {{ currentContact.name }}
                    </span>
                </template>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="10">
                <span class="gray">
                    Телефон
                </span>
            </el-col>
            <el-col :span="14">
                <template v-for="(contactPhone, index) in currentContact.contact_phones">
                    <div :key="index" class="tel-item">
                        <template v-if="editMode">
                            <el-col :span="20" :class="['mb10', { 'error-input': errors.phone }]">
                                <div class="el-input el-input--mini">
                                    <the-mask
                                        v-model="contactPhone.phone"
                                        mask="+F (FFF) FFF-FF-FF"
                                        placeholder="+7 (495) 123-45-67"
                                        class="el-input__inner"
                                        :tokens="tokens"
                                    />
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <div class="pt5 pl5 pointer" @click="calltoPhone(contactPhone.phone)">
                                    <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                                </div>
                            </el-col>
                            <el-col :span="2" v-if="!isMain(contactPhone)">
                                <div class="delete-phone" @click="deletePhone(index, contactPhone)">
                                    <i class="el-icon-close"></i>
                                </div>
                            </el-col>
                        </template>
                        <template v-else>
                            {{ masker(contactPhone.phone, '+# (###) ###-##-##', true, tokens) }}
                        </template>
                    </div>
                    <template v-if="editMode">
                        <div class="field-error" v-if="errors[`contact_phones.${index}.phone`]" :key="index+'error'">
                            {{ errors[`contact_phones.${index}.phone`][0] }}
                        </div>
                    </template>
                </template>
                <div class="ml0" v-if="editMode">
                    <el-col>
                        <el-button class="button-icon" size="mini" @click="addNewPhone">
                            <font-awesome-icon icon="plus" class="orange" />
                        </el-button>
                    </el-col>
                </div>
            </el-col>
        </el-row>
        <el-row :class="{ pb16: !showSaveBtn }">
            <el-col :span="10">
                <span class="gray" :class="{ 'error-input': errors.email }">
                    e-mail
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode">
                    <el-input v-model="currentContact.email" size="mini" />
                    <div class="field-error" v-if="errors.email" v-text="errors.email[0]"></div>
                </template>
                <template v-else>
                    {{ currentContact.email }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="editMode && showSaveBtn" class="pb0">
            <el-col :span="14" :offset="10" class="mb10">
                <el-button class="spreadsheet-header-button" type="warning" size="mini" @click="saveContact">
                    Сохранить контакт
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Contact from '@/components/Contact';
import masker from '@/components/vue-the-mask/src/masker';

const tokens = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/ },
    'S': { pattern: /[a-zA-Z]/ },
    'A': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
    'a': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
    'F': { pattern: /[\d*]/ },
    '!': { escape: true }
};

export default {
    name: 'ContactDealCard',
    data() {
        return {
            tokens
        };
    },
    extends: Contact,
    props: {
        editMode: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        masker
    }
};
</script>
